import TagInput from './tag-input';

export default TagInput;
